import { ProblemReport } from '@quizzach/assets';
import { Colors, Text } from '@quizzach/styles';
import { OptionsKebab } from '@quizzach/play-styles';
import { useState, useRef, useEffect } from 'react';
import { FaEllipsisVertical } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';

export const BottomNavOptions = ({
	setShowModal,
}: {
	setShowModal: (show: boolean) => void;
}) => {
	const { t } = useTranslation();
	const [menuOpen, setMenuOpen] = useState(false);
	const menuRef = useRef<HTMLDivElement | null>(null);
	const toggleMenu = () => setMenuOpen((prev) => !prev);

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
				setMenuOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	return (
		<OptionsKebab>
			<div className='menu-container' ref={menuRef}>
				<div className='kebab-menu' onClick={toggleMenu}>
					<FaEllipsisVertical className='kebab-icon' />
				</div>
				{menuOpen && (
					<div className='dropdown-menu'>
						<ul>
							<li onClick={() => setShowModal(true)}>
								<ProblemReport size={20} color={Colors.textMain} />
								<Text
									color={Colors.textMain}
									style={{ margin: '10px 0px 10px 20px' }}
								>
									{t('quiz.options.reportProblem')}
								</Text>
							</li>
						</ul>
					</div>
				)}
			</div>
		</OptionsKebab>
	);
};
